import { Instagram, MapPin } from "lucide-react";

export const IconInstagram = (props) => <Instagram {...props} />;
export const IconMapPin = (props) => <MapPin {...props} />;

export function IconWhatsApp({ size = 22, strokeWidth = 1.6, className = "" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d="M3.5 20.5l1.3-4.75a8.5 8.5 0 1 1 3.32 3.29L3.5 20.5z" />
      <path d="M8.4 9.4c.3-.2.7-.2 1 0 .4.3.7.9.9 1.6.1.4-.1.7-.4 1l-.5.5a6 6 0 0 0 2.8 2.8l.5-.5c.3-.3.6-.5 1-.4.7.2 1.3.5 1.6.9.2.3.2.7 0 1-.5.7-1.4 1.4-2.6 1.4-2.7 0-6.4-3.7-6.4-6.4 0-1.2.7-2.1 1.4-2.6a.8.8 0 0 1 .7 0z" />
    </svg>
  );
}
